"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductionUrl = exports.getUrlParam = void 0;
function getUrlParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}
exports.getUrlParam = getUrlParam;
function isProductionUrl(url) {
    return [
        'localhost',
        'biz-tecma',
        '-demo.tecmasolutions.com',
        '.ddns.net', // ddns
    ].every((substring) => !url.includes(substring));
}
exports.isProductionUrl = isProductionUrl;
